import {
  RiBold,
  RiCodeLine,
  RiItalic,
  RiStrikethrough,
  RiUnderline,
} from '@remixicon/react';
import { useEditorState } from '@tiptap/react';

import { ButtonIcon, Flex } from '@backstage/ui';

import { useCurrentEditor } from './Context';
import { AddLinkButton } from './Link/AddLinkButton';
import { TextColorButton } from './TextColorButton';

export const InlineFormatButtons = () => {
  const { editor } = useCurrentEditor();

  const isActiveBold = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('bold') ?? false,
  });

  const isActiveItalic = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('italic') ?? false,
  });

  const isActiveUnderline = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('underline') ?? false,
  });

  const isActiveStrike = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('strike') ?? false,
  });

  const isActiveCode = !!useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('code') ?? false,
  });

  return (
    <Flex gap="0.5">
      <ButtonIcon
        size="small"
        icon={<RiBold />}
        onClick={() => editor?.chain().focus().toggleBold().run()}
        variant={isActiveBold ? 'primary' : 'tertiary'}
        isDisabled={isActiveCode}
        aria-label="Bold"
      />
      <ButtonIcon
        size="small"
        icon={<RiItalic />}
        onClick={() => editor?.chain().focus().toggleItalic().run()}
        variant={isActiveItalic ? 'primary' : 'tertiary'}
        isDisabled={isActiveCode}
        aria-label="Italic"
      />
      <ButtonIcon
        size="small"
        icon={<RiUnderline />}
        onClick={() => editor?.chain().focus().toggleUnderline().run()}
        variant={isActiveUnderline ? 'primary' : 'tertiary'}
        isDisabled={isActiveCode}
        aria-label="Underline"
      />
      <ButtonIcon
        size="small"
        icon={<RiStrikethrough />}
        onClick={() => editor?.chain().focus().toggleStrike().run()}
        variant={isActiveStrike ? 'primary' : 'tertiary'}
        isDisabled={isActiveCode}
        aria-label="Strikethrough"
      />
      <TextColorButton />
      <AddLinkButton />
      <ButtonIcon
        size="small"
        icon={<RiCodeLine />}
        onClick={() => editor?.chain().focus().toggleCode().run()}
        variant={isActiveCode ? 'primary' : 'tertiary'}
        aria-label="Code"
      />
    </Flex>
  );
};
